<div class="release-notes-container">
  <div class="page-header">
    <h1 class="mat-h1 page-title">Release Notes</h1>
    <button mat-mini-fab class="collapse-all-btn" (click)="toggleAllPanels()">
      <mat-icon>{{ allExpanded ? 'unfold_less' : 'unfold_more' }}</mat-icon>
    </button>
  </div>

  <div class="release-notes-layout">
    <!-- Vertical menu of versions with Material List -->
    <mat-card class="version-menu-card">
      <mat-card-header>
        <mat-card-title>Versions</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-nav-list>
          <mat-list-item *ngFor="let note of releaseNotes; let i = index"
                       [class.active-version]="selectedVersionIndex === i"
                       (click)="selectVersion(i)"
                       tabindex="0"
                       [attr.aria-selected]="selectedVersionIndex === i"
                       [attr.aria-current]="selectedVersionIndex === i ? 'page' : null">
            <span matListItemTitle class="version-number">{{note.version}}</span>
            <span matListItemLine class="version-date">{{note.date | date:'dd/MM/yyyy'}}</span>
          </mat-list-item>
        </mat-nav-list>
      </mat-card-content>
    </mat-card>

    <!-- Detailed content of the selected version with Material Card -->
    <mat-card class="version-content-card" *ngIf="selectedVersion">
      <mat-card-header>
        <div class="version-header-content">
          <mat-card-title>Version {{selectedVersion.version}} - {{selectedVersion.date | date:'dd/MM/yyyy'}}</mat-card-title>
          <mat-card-subtitle>{{selectedVersion.title}}</mat-card-subtitle>
        </div>
      </mat-card-header>
      <mat-card-content>
        <p class="version-description">{{selectedVersion.description}}</p>

        <mat-divider *ngIf="selectedVersion.items && selectedVersion.items.length > 0"></mat-divider>

        <div *ngIf="selectedVersion.items && selectedVersion.items.length > 0" class="version-items">
          <div class="details-header">
            <h3 class="mat-h3 details-title">Changes Details</h3>
            <div class="criticality-filter">
              <button mat-mini-fab class="criticality-btn high-btn"
                      [class.active]="isFilterActive('high')"
                      matTooltip="Critical - Major fix"
                      (click)="toggleCriticalityFilter('high')">
                <mat-icon>priority_high</mat-icon>
              </button>
              <button mat-mini-fab class="criticality-btn medium-btn"
                      [class.active]="isFilterActive('medium')"
                      matTooltip="Important - Significant improvement"
                      (click)="toggleCriticalityFilter('medium')">
                <mat-icon>arrow_upward</mat-icon>
              </button>
              <button mat-mini-fab class="criticality-btn technical-btn"
                      [class.active]="isFilterActive('technical')"
                      matTooltip="Technical - Internal modification"
                      (click)="toggleCriticalityFilter('technical')">
                <mat-icon>code</mat-icon>
              </button>
              <button mat-mini-fab class="criticality-btn trivial-btn"
                      [class.active]="isFilterActive('trivial')"
                      matTooltip="Minor - Small improvement"
                      (click)="toggleCriticalityFilter('trivial')">
                <mat-icon>low_priority</mat-icon>
              </button>
            </div>
          </div>

          <mat-accordion multi>
            <mat-expansion-panel *ngFor="let item of selectedVersion.items; let j = index"
                                class="item-panel"
                                [expanded]="panelOpenState[j]"
                                (opened)="setPanelState(j, true)"
                                (closed)="setPanelState(j, false)"
                                [ngClass]="'criticality-' + (item.criticality || 'default')">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <div class="panel-title-container">
                    <div class="criticality-indicator" [ngClass]="'criticality-' + (item.criticality || 'default') + '-indicator'">
                      <mat-icon>{{getCriticalityIcon(item.criticality)}}</mat-icon>
                    </div>
                    <span class="item-title-text">{{item.title}}</span>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="item-description-container">
                <p class="item-description">{{item.description}}</p>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
